import React from 'react';
import styled from '@emotion/styled';

const Wrapper = styled('div')`
  position: fixed;
  width: calc(100% - 240px);
  z-index: 100;
  bottom: ${(props) => (props.show ? '0' : '-100px')};
  left: 0;
  margin-left: 240px;
  background-color: #ffffff;
  border-top: 1px solid #c4c5d69e;
  visibility: ${(props) => (props.show ? 'visible' : 'hidden')};
  transition-duration: 0.3s;
  @media (max-width: 767.98px) {
    margin-left: 0;
    width: 100%;
  }
  .fixed-panel-inner {
    display: flex;
    padding: 15px 20px;

    .clear-selected a {
      text-decoration: underline;
    }

    .buttons-block {
      margin-left: auto;
    }

    @media (max-width: 535px) {
      display: block;
    }

    @media (max-width: 395px) {
      .buttons-block button span {
        display: none;
      }
    }
  }
`;

const FixedPanel = (props) => {
  const { show, children } = props;
  return <Wrapper show={show}>{children}</Wrapper>;
};

export default FixedPanel;
